import styles from './producto-page.module.scss';
import React from "react";
import { Link } from "react-router-dom";

import api, { Product } from "../../services/api";

export interface ProductoPageProps {
  name?: string;
  classes?: string;
  match?: { slug?: string };
}

interface State {
  product: Product | null;
  loading: boolean;
  notFound: boolean;
}

/**
 * Presentación de producto (detalle). Datos del API (`/api/products/:slug`).
 */
export default class ProductoPage extends React.Component<ProductoPageProps, State> {
  static jsClass = "ProductoPage";
  static defaultProps: Partial<ProductoPageProps> = {
    name: "mbProducto",
  };

  state: State = { product: null, loading: true, notFound: false };

  componentDidMount() {
    const slug = this.props.match?.slug ?? "";
    api
      .getProduct(slug)
      .then((product) => this.setState({ product, loading: false, notFound: !product }))
      .catch(() => this.setState({ loading: false, notFound: true }));
  }

  render(): React.ReactNode {
    const { classes } = this.props;
    const { product, loading, notFound } = this.state;

    if (loading) {
      return <section className={styles['mb-notfound']}><p>Cargando producto…</p></section>;
    }

    if (notFound || !product) {
      return (
        <section className={styles['mb-notfound']}>
          <h1 className={styles['mb-notfound__title']}>Producto no encontrado</h1>
          <p className={styles['mb-notfound__copy']}>
            El producto que buscas no existe o cambió de dirección.
          </p>
          <Link className={styles['mb-btn']} to="/productos">
            Volver al catálogo
          </Link>
        </section>
      );
    }

    return (
      <article className={styles['mb-producto'] + (classes ? ' ' + classes : '')}>
        <div className={styles['mb-producto__grid']}>
          {/* ── Columna izquierda ─────────────────────────────────────────── */}
          <div className={styles['mb-producto__main']}>
            <h1 className={styles['mb-producto__title']}>{product.nombre}</h1>

            <ul className={styles['mb-meta']}>
              <li>
                <span className={styles['mb-meta__k']}>Categoría:</span> {product.categoria}
              </li>
              <li>
                <span className={styles['mb-meta__k']}>Precio:</span> $
                {product.precio.toLocaleString("es-MX")} por {product.unidad}
              </li>
              <li>
                <span className={styles['mb-meta__k']}>Presentación:</span> pieza
              </li>
            </ul>

            <p className={styles['mb-producto__h']}>Descripción:</p>
            <p className={styles['mb-producto__desc']}>{product.descripcion}</p>

            <div className={styles['mb-producto__actions']}>
              <Link className={styles['mb-btn']} to="/recetario">
                Ver recetario
              </Link>
              <Link className={styles['mb-btn']} to="/contacto">
                Contacto
              </Link>
            </div>
          </div>

          {/* ── Columna derecha (navy) ────────────────────────────────────── */}
          <aside className={styles['mb-producto__side']}>
            <img
              className={styles['mb-producto__img']}
              src={product.imagen}
              alt={product.nombre}
            />
            <h2 className={styles['mb-producto__h'] + ' ' + styles['mb-producto__h--light']}>
              {product.categoria}
            </h2>
            <p className={styles['mb-producto__side-desc']}>{product.descripcion}</p>
            <p className={styles['mb-producto__price']}>
              ${product.precio.toLocaleString("es-MX")} <small>por {product.unidad}</small>
            </p>
          </aside>
        </div>
      </article>
    );
  }
}
